var exports = {
  "U5": "Overlay_0__pXyGlP",
  "BG": "MenuTitleWithVisual__qrUbC4",
  "h": "suggestion__lNPZhM",
  "U3": "ActionList_0__k18x-M",
};

module.exports = exports;
